module.exports = __webpack_public_path__ + "static/media/notification.651771e1.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/notification.woff
// module id = 152
// module chunks = 0